<template>
    <header class="header" :class="{ 'scrolled3head': isScrolled }">
        <div class="vertical-container">
            <div class="imghead" :class="{ 'scrolled3headimg': isScrolled }">
                <img @click="opens(0)"  src="../../assets/logo1.png" />
            </div>
            <div class="headcont" :class="{ 'scrolled3headcont': isScrolled }">
                <div style="position: absolute; display: flex; 
    justify-content: space-between; 
    align-items: center; width: 90vw;">
                <div style="opacity: 0;"  @click="opens(0)"  :class="{ 'scrolled3logo': isScrolled }"><img style="width: 3.5rem;height: 1rem" src="../../assets/logo1.png" alt="" @click="main1()"></div>

                <div style="display: flex; 
    justify-content: space-between; width: 10rem;">
  
                <div  @click="opens(1)":class="{ 'scrolled3logo': isScrolled }"><img style="cursor: pointer; width:1.5rem" src="../../assets/pic-24cccc.png" alt="" @click="opens(999)"></div>
               
                <div :class="{ 'scrolled3logo': isScrolled }">
                    <img style=" width: 1.5rem;" src="../../assets/pic-25a.jpg" alt="">
                </div>
                
            <div style="display: flex; align-items: flex-start;">
                <div :class="{ 'scrolled3logo': isScrolled }"class="tit" @click="clickLang(1)">中</div>
                <div :class="{ 'scrolled3logo': isScrolled }"class="tit" @click="clickLang(1)">|</div>
                <div style="margin-top: 0.2vh;"  :class="{ 'scrolled3logo': isScrolled }"class="tit" @click="clickLang(2)">EN</div>
            </div>
            </div>
                </div>

                <!-- Dropdown Menu Start -->
                <!-- 导航菜单 -->
                <ul class="nav-list">
                    <li v-for="menu in menus" :key="menu.title" class="nav-item">
                        <!-- 切换菜单标题 -->
                        <span class="span1head" @click="opens(menu.titleEN)">{{ showEnglish ? menu.titleEN : menu.title }}</span>
                        <ul class="submenu" :class="{ 'submenuhead': menu.items.length === 0 }">
                            <li v-for="subItem in menu.items" :key="subItem.title" class="submenu-item" @click="opens(subItem.collectionKey)">
                                <img :src="subItem.img" alt="" class="submenu-img" />
                                <!-- 切换子菜单标题 -->
                                <span class="submenu-text">{{ showEnglish ? subItem.titleEN : subItem.title }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
                <!-- Dropdown Menu End -->
            </div>
        </div>
    </header>
</template>

<script>
   import axios from 'axios';
   import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
   import { mapActions } from 'vuex'; // 确保导入 mapActions
    export default {
        props: {
            isScrolled: {
                type: Boolean,
                default: false
            }
        },
        components:{
           
        },
        data() {
            return {

                currentIndex: 0,
                title: {
                    pukititle: false,
                },
                isMobile: false,
                sections: [],
                showEnglish: false, // 控制是否显示英文
                // menus: [
                //     {
                //         title: '探索谱褀',
                //         titleEN:'sddd',
                //         items: [
                          
                //             { title: '品牌定位', img: require('../../assets/pic-icon-11.png') ,collectionKey:'pingpaidingwei',titleEN:'sddd'},
                //             { title: '研发设计', img: require('../../assets/pic-icon-12.png') ,collectionKey:'ddd',titleEN:'sddd'},
                //             { title: '绿色智造', img: require('../../assets/pic-icon-13.png') ,collectionKey:'ddd',titleEN:'sddd'},
                //             { title: '展示中心', img: require('../../assets/pic-icon-14.png') ,collectionKey:'exhibitioncenter',titleEN:'sddd'},
                //         ],
                //     },
                //     {
                //         title: '产品选购',
                //         titleEN:'sddd',
                //         items: [
                //             // { title: '', img: '' },
                //             { title: ' \u00A0P系列', img: require('../../assets/pic-icon-18.png') ,collectionKey:'collectionA',titleEN:'sddd'},
                //             { title: ' \u00A0U系列', img: require('../../assets/pic-icon-19.png') ,collectionKey:'collectionB',titleEN:'sddd'},
                //             { title: ' \u00A0K系列', img: require('../../assets/pic-icon-22.png') ,collectionKey:'collectionK',titleEN:'sddd'},
                //             { title: ' \u00A0E系列', img: require('../../assets/pic-icon-20.png') ,collectionKey:'collectionE',titleEN:'sddd'},
                //             { title: ' \u00A0\u00A0C系列', img: require('../../assets/pic-icon-21.png') ,collectionKey:'collectionC',titleEN:'sddd'},
                //             { title: ' \u00A0\u00A0更多...', img: require('../../assets/pic-icon-40.png'),collectionKey:'collectionMore',titleEN:'sddd'},


                //         ],
                //     },
                //     {
                //         title: '用户服务',
                //         titleEN:'sddd',
                //         items: [
                //             { title: '售后服务', img: require('../../assets/pic-icon-17-17.png') ,collectionKey:'ddd',titleEN:'sddd'},
                //             { title: '联系我们', img: require('../../assets/pic-icon-16.png') ,collectionKey:'ddd',titleEN:'sddd'},
                //             { title: '常见问题', img:require('../../assets/pic-icon-15.png') ,collectionKey:'ddd',titleEN:'sddd'},
                //         ],
                //     },
                //     {
                //         title: '营销网络',
                //         titleEN:'xisaoshouwangluo',
                //         items: [

                //         ],
                //     },
                //     {
                //         title: '合作伙伴',
                //         titleEN:'sddd',
                //         items: [

                //         ],
                //     },
                // ],
                menus:[]
            };
        },
        // computed(){
        //
        // },

        mounted() {
            // console.log('Store:', this.$store); // 检查 store 是否可用
            this.fetchMenus();  // 组件挂载后请求数据
            window.addEventListener('scroll', this.handleScroll);

        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            /**
             * 查询导航栏数据
             */
            async fetchMenus() {
                try {
                    const response = await axios.get(`${apiUrls.baseUrl}/website/api/menus`);
                //    console.log(response)
                //    console.log(`${apiUrls.devApi}`)
                   // 查询到的菜单数据
                    const menusDataFromDb = response.data;
                    // 转换函数，将数据库结果转换为前端所需的格式

                    function transformMenus(data) {
                    return data.map(menu => ({
                        title: menu.title,
                        titleEN: menu.titleEn,
                        
                        items: menu.submenusList.map(submenu => ({
                        // 如果 title 是 3 个字，就在其后添加一个零宽字符 \u200B
                        //  title: submenu.title.length === 3 ? '\u2003'+submenu.title  : submenu.title,
                        title: submenu.title.length === 3 ? submenu.title  : submenu.title,
                        titleEN: submenu.titleEn,
                        collectionKey: submenu.collectionKey,
                        img: `${apiUrls.devApi}${submenu.imgPath}`

                        }))
                    }));
                    };
                    // 转换后的前端菜单数据
                  this.menus = transformMenus(menusDataFromDb);
                } catch (error) {

                    // _________________________________________________________

                    this.menus=  [
                    {
                        title: '探索谱褀',
                        titleEN:'sddd',
                        items: [
                          
                            { title: '品牌定位', img: require('../../assets/pic-icon-11.png') ,collectionKey:'pingpaidingwei',titleEN:'sddd'},
                            { title: '研发设计', img: require('../../assets/pic-icon-12.png') ,collectionKey:'ddd',titleEN:'sddd'},
                            { title: '绿色智造', img: require('../../assets/pic-icon-13.png') ,collectionKey:'ddd',titleEN:'sddd'},
                            { title: '展示中心', img: require('../../assets/pic-icon-14.png') ,collectionKey:'exhibitioncenter',titleEN:'sddd'},
                        ],
                    },
                    {
                        title: '产品选购',
                        titleEN:'sddd',
                        items: [
                            // { title: '', img: '' },
                            { title: ' \u00A0P系列', img: require('../../assets/pic-icon-18.png') ,collectionKey:'collectionA',titleEN:'sddd'},
                            { title: ' \u00A0U系列', img: require('../../assets/pic-icon-19.png') ,collectionKey:'collectionB',titleEN:'sddd'},
                            { title: ' \u00A0K系列', img: require('../../assets/pic-icon-22.png') ,collectionKey:'collectionK',titleEN:'sddd'},
                            { title: ' \u00A0E系列', img: require('../../assets/pic-icon-20.png') ,collectionKey:'collectionE',titleEN:'sddd'},
                            { title: ' \u00A0\u00A0C系列', img: require('../../assets/pic-icon-21.png') ,collectionKey:'collectionC',titleEN:'sddd'},
                            { title: ' \u00A0\u00A0更多...', img: require('../../assets/pic-icon-40.png'),collectionKey:'collectionMore',titleEN:'sddd'},


                        ],
                    },
                    {
                        title: '用户服务',
                        titleEN:'sddd',
                        items: [
                            { title: '售后服务', img: require('../../assets/pic-icon-17-17.png') ,collectionKey:'ddd',titleEN:'sddd'},
                            { title: '联系我们', img: require('../../assets/pic-icon-16.png') ,collectionKey:'ddd',titleEN:'sddd'},
                            { title: '常见问题', img:require('../../assets/pic-icon-15.png') ,collectionKey:'ddd',titleEN:'sddd'},
                        ],
                    },
                    {
                        title: '营销网络',
                        titleEN:'xisaoshouwangluo',
                        items: [

                        ],
                    },
                    {
                        title: '合作伙伴',
                        titleEN:'sddd',
                        items: [

                        ],
                    },
                ],


                    // _________________________________________________________


                    console.error('Error fetching menus:', error);
                    }
              },
              // ... 现有的方法
              ...mapActions(['changeLanguage']), // 确保这里的名称与 Vuex 的 action 名称一致
                clickLang(type) {
                    const isEnglish = type === 2; // 判断是否选择英语
                    this.changeLanguage(isEnglish); // 调用 Vuex 的 action
                    
                    this.showEnglish = isEnglish; // 更新本地状态以用于 UI
                    // this.$i18n.locale = isEnglish ? 'en' : 'zh'; // 更新 i18n 的语言设置

                    // // 应用字体更改
                    // const bodyElement = document.body;
                    // bodyElement.style.fontFamily = isEnglish ? 'Montserrat-Normal' : 'Montserrat-Normal';
                },
            opens(id){
                // 跳转商业合作页面
                if(id==='exhibitioncenter' &&this.$route.name !== 'exhibitioncenter'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'exhibitioncenter'})


                }
                // 跳转商业合作页面
                if(id==='pingpaidingwei' &&this.$route.name !== 'positioning'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'positioning'})


                }
                // 跳转商业合作页面
                if(id==='xisaoshouwangluo' &&this.$route.name !== 'xiaoshouwangluo'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'xiaoshouwangluo'})


                }
                if(id===1 &&this.$route.name !== 'searchnew'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'searchnew'})


                }
                if(id===0 &&this.$route.name !== 'indexmain'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'indexmain'})


                }

                if (id === 'collectionE' ||id === 'collectionA' || id === 'collectionB' || id === 'collectionC' ||id === 'collectionK' || id === 'collectionU') {
                    // console.log(id)
                    try {
                        // 判断当前路由是否是 'products'
                        if (this.$route.name === 'products') {
                            // 如果当前路由是 products，刷新页面
                            this.$router.replace({ name: 'products', params: { id: id } }).catch(err => {});
                            this.$router.go(0); // 重新加载当前页面
                        } else {
                            // 如果不是 products，则进行正常的跳转，不刷新  
                            this.$router.push({ name: 'products', params: { id: id } }).catch(err => {});
                        }
                    } catch (error) {
                        console.error("跳转失败：", error);
                    }
                } 
                
                if(id==='researchdesign' &&this.$route.name !== 'researchdesign'){
                    this.$router.push({name: id})
                }
                if(id==='greenmanufacturing' &&this.$route.name !== 'greenmanufacturing'){
                    this.$router.push({name: id})
                }
                if(id==='aftersales' &&this.$route.name !== 'aftersales'){
                    this.$router.push({name: id})
                }

                if(id==='Instructions' &&this.$route.name !== 'Instructions'){
                    this.$router.push({name: id})
                }
                if(id==='faqs' &&this.$route.name !== 'faqs'){
                    this.$router.push({name: id})
                }
                if(id==='Partners' &&this.$route.name !== 'Partners'){
                    this.$router.push({name: id})
                }
                if(id===999 &&this.$route.name !== 'search'){
                    this.$router.push({name: 'search'})
                }
                if(id==='Sales Network' &&this.$route.name !== 'salesnetwork'){
                    this.$router.push({name: 'salesnetwork'})
                }

            },
            /**
             * 判断手机或者电脑然后跳转相应的路由
             */
            isMobiles(){
                // 解释:
                    // 1. `/iPhone|iPad|iPod|Android/i` - 这是一个正则表达式，
                    //    它会匹配包含 "iPhone"、"iPad"、"iPod" 或 "Android" 字符串的内容。
                    //    - `|` 表示“或”运算符，匹配其中的任意一个关键字。
                    //    - `/i` 表示忽略大小写（即 "iphone"、"Iphone"、"IPHONE" 等都会匹配）。
                    // 2. `navigator.userAgent` - 这是浏览器的用户代理字符串，它包含了设备、操作系统、浏览器等信息。
                    //    例如，iPhone 的 `userAgent` 字符串可能包含 "iPhone" 字样。
                    // 3. `test(navigator.userAgent)` - 使用正则表达式 `test` 方法来检查 `navigator.userAgent` 字符串中
                    //    是否包含上述的任何一个关键字。如果匹配，返回 `true`；否则，返回 `false`。
                    // 4. `const isMobile` - 根据 `test` 方法的返回值将结果存储到 `isMobile` 变量中。
                    //    - 如果设备是手机或平板，`isMobile` 为 `true`。
                    //    - 如果设备是桌面设备（如 PC 或 Mac），`isMobile` 为 `false`。
                // 判断是否是手机
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    // console.log("++++++++++++++++++++++=======================")
                
                    //如果是手机
                        if(isMobile){
                        // 判断当前路由是否已经是目标路由，如果是则不进行跳转
                        if (this.$route.name !== 'indexmainh5') {
                        this.$router.push({ name: 'indexmainh5' });
                        }
                    }
            },   
        },

       

        created() {
                this.isMobiles();
        },
    };
</script>

<style scoped>

* {
    max-width: 100vw; /* 强制所有元素的最大宽度不超过视口 */
    box-sizing: border-box; /* 包含内边距和边框在元素宽度内 */
 
}




    /* 导航栏滑动样式结束 */
    /*滑动logo开始*/
    .scrolled3logo{
        opacity: 1!important;
        display: block!important;
        transition: top 1.3s ease-in-out; /* 过渡动画 */
        top: 0.3vh!important;
    }
    /*滑动logo结束*/
    /* 导航栏滑动样式开始 */
    .scrolled3headimg {

        transition: display;
        display: none!important;

    }
    .scrolled3headcont {}

    .scrolled3head {
        /*max-height: 0;*/
        /*overflow: hidden; !* 确保内容在 max-height 为 0 时被隐藏 *!*/
        transition: height 1s ease-in-out; /* 过渡动画 */
        height: 8vh!important;
    }
    .header .vertical-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .imghead,
    .headcont {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-bottom: 1px solid #b9b7b7;
    }

    .imghead img {
        height: 3vh;
    }

    .headcont {
        justify-content: space-around;
        width: 100%;
        text-align: center;
    }

    .header {
        width: 100vw;
        transition: height 1s ease-in-out;
        height: 16vh;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        position: sticky!important;
        top: 0;
        z-index: 1000; /* 提高导航栏的 z-index */
        margin: 0;
        padding: 0;
       
    }

    .nav-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        position: relative;
    }

    .nav-item {

        margin: 0 50px;
        cursor: pointer;
    }

    .submenu {
        display: none;
        position: absolute;
        top: 100%;
        left: calc(50% - 50vw); /* 使菜单居中于父元素 */
        background-color: white;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0);
        list-style: none;
        padding: 10px;
        margin: 0;
        width:100vw; /* 子菜单宽度 */
        min-width: 100%;
        height: 25vh;
        z-index: 2000; /* 增加下拉菜单的 z-index */


    }
    /*没有子菜单就隐藏开始*/
    .nav-item:hover .submenuhead{
        display: none!important;
        z-index: 999;
    }
    /*没有子菜单就隐藏结束*/
    .nav-item:hover .submenu {
        display: flex;
        justify-content: center; /* 水平居中对齐子菜单项 */
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        z-index: 2000; /* 确保下拉菜单始终位于前面 */
    }
    .nav-item:hover .span1head {
        font-weight: bold;
        z-index: 999;
    }

    .submenu-item {
        display: flex;
        flex-direction: column; /* 设置为上下排列 */
        align-items: center; /* 水平居中 */
        justify-content: center; /* 垂直居中 */
       text-align: center;  /*!* 文字居中对齐 *!*/
        padding: 10px; /* 调整内边距 */
         /*margin: 0 8px; 减少外边距，缩短间距 */

         /*text-align: left; 文字左对齐 */
        z-index: 999;

    }

    .submenu-img {

        /* height: 25vh; */
        /*margin-right: 2vw;*/
        margin-bottom: 10px; /* 图片与文字之间的距离 */
        width: 6vw;
        height: auto;
        z-index: 999!important;

    }

    .submenu-text {
        font-size: 0.8rem;
        width: 5vw;
       display: flex;
       text-align: center;
       justify-content: center;
        /* margin-right: -2vw;*/
        font-weight: 300;
        color: #808080;
        z-index: 999!important;
    }
    /*导航栏结束*/

/*    手机端样式隐藏*/
    @media screen and (max-width: 768px) {


        .header {
            display: none;
        }
    }
/*    手机端样式隐藏
*/
</style>
